export function removeGqlGarbageFromArrays(array) {
  if (!array || !Array.isArray(array)) return [];

  const arrayCopy = [...array];
  return arrayCopy.map((item) => {
    const itemCopy = { ...item };
    delete itemCopy?.['__typename'];
    delete itemCopy?.['__schema'];
    delete itemCopy?.['__type'];
    return itemCopy;
  });
}

/**
 * Recursively removes GraphQL garbage fields from arrays and objects
 * @param {Array|Object} data - The data to clean
 * @returns {Array|Object} - Cleaned data with all GraphQL garbage removed
 */
export function removeGqlGarbageRecursively(data) {
  // Handle null/undefined case
  if (data == null) return data;

  // Handle array case
  if (Array.isArray(data)) {
    return data.map((item) => removeGqlGarbageRecursively(item));
  }

  // Handle object case
  if (typeof data === 'object') {
    const result = { ...data };

    // Remove GraphQL garbage fields
    delete result?.['__typename'];
    delete result?.['__schema'];
    delete result?.['__type'];

    // Process each property recursively
    for (const key in result) {
      if (Object.prototype.hasOwnProperty.call(result, key)) {
        result[key] = removeGqlGarbageRecursively(result[key]);
      }
    }

    return result;
  }

  // For primitive values (string, number, boolean), return as is
  return data;
}
